import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../../tasks/models/task.model";

export class PlanningRouteTasksTableItemComponent implements IController {

  index: number;
  task: TaskModel;
  taskAnalysis: any;
  isHighlighted: boolean;
  isBundle: boolean;
  toggle: Function;

  private purposeToServiceType: any;
  private isMobile: boolean;
  private isShowDeleteIcon: boolean;

  /* @ngInject */
  constructor(private tasksConstants, private $mdMedia) {}

  $onInit() {
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.isMobile = !this.$mdMedia('gt-sm');
    this.isShowDeleteIcon = false;
  };

  swipeLeft() {
    this.isShowDeleteIcon = this.isMobile;
  }

  swipeRight() {
    this.isShowDeleteIcon = false;
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTasksTableItem', {
    require:{
      planningRouteTasksTableCtrl: '^planningRouteTasksTable'
    },
    bindings: {
      index: '<',
      task: '<',
      taskAnalysis: '<',
      isHighlighted: '<',
      isBundle: '<',
      toggle: '&'
    },
    template: require('./planning-route-tasks-table-item.html').default,
    controller: PlanningRouteTasksTableItemComponent
  });
